import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-destinations',
  templateUrl: './help-destinations.component.html',
  styleUrls: ['./help-destinations.component.scss']
})
export class HelpDestinationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
